<template>
  <div class="move-home">
    <div class="move-container">
      <a-space>
        <a-textarea
          class="goods-url-textarea"
          allowClear
          v-model:value="text"
          :placeholder="`请输入【1688】商品详情链接，必须一行一个商品链接，一次最多【${maxCount}】个链接`"
          :auto-size="{ minRows: 15, maxRows: 20 }"
        />
      </a-space>
      <CreateGoodsTemplateModal ref="createGoodsTemplateModal" hideOpenDouyinButton />
      <a-space>
        <a-button type="primary" class="move" :loading="loading" @click="movePreview">
          铺货预览
        </a-button>
      </a-space>
      <div style="margin-top: 1em">
        <a-tag color="red" style="font-size: 15px">
          温馨提示：商品模板里的发布模式选择【立即上架】，支付宝后台会有审核不通过的情况
        </a-tag>
      </div>
    </div>
  </div>
</template>
<script>
import CreateGoodsTemplateModal from '@/views/moving_function/components/create_goods_template_modal'
import handler from './handler'
export default {
  components: { CreateGoodsTemplateModal },
  data() {
    return {
      text: "",
      maxCount: 200,
      loading: false
    }
  },
  methods: {
    // 点击【铺货预览】时执行
    async movePreview() {
      if (!this.text?.length) return this.$message.warning('请先输入商品详情链接')
      const count = this.text.split('\n')
      if (count?.length > this.maxCount) return this.$message.warning(`一次最多只支持【${this.maxCount}】个链接，当前有【${count.length}】个链接`)
      const goodsTemplateId = this.$refs.createGoodsTemplateModal.goodsTemplateId
      this.loading = true
      const list = await handler.GetFinalGoodsUrls({ text: this.text, goodsTemplateId })
      this.loading = false
      this.$emit('move-preview', { list, goodsTemplateId })
    }
  }
};
</script>
<style scoped lang="less">
  @import './index';
</style>